export default {
  title: 'Kontakt i synchronizacja',
  labels: {
    occ_phone_number: 'Numer telefonu call center',
    company_phone_number: 'Numer telefonu restauracji',
    has_google_business_sync: 'Synchronizuj z Google Business',
    has_foodamigos_sync: 'Synchronizuj z usługami Fooodamigos',
  },
  placeholders: {
    occ_phone_number: 'Wybierz numer telefonu z listy',
  },
};
